import axios from 'axios';
import { getCookie, setCookie, removeCookie } from './cookieUtils';

const api = axios.create({
    baseURL: 'https://backend.ithyaraa.com/api',
    withCredentials: false
});

api.interceptors.request.use((config) => {
    const token = getCookie('brand_access_token');
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

let isRefreshing = false;
let pendingQueue = [];

function processQueue(error, token = null) {
    pendingQueue.forEach((p) => {
        if (error) p.reject(error);
        else p.resolve(token);
    });
    pendingQueue = [];
}

api.interceptors.response.use(
    (res) => res,
    async (error) => {
        const original = error.config || {};
        if (error.response && error.response.status === 401 && !original._retry) {
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    pendingQueue.push({ resolve, reject });
                })
                    .then((newToken) => {
                        original.headers.Authorization = `Bearer ${newToken}`;
                        return api(original);
                    })
                    .catch((err) => Promise.reject(err));
            }

            original._retry = true;
            isRefreshing = true;
            try {
                const refreshToken = getCookie('brand_refresh_token');
                const { data } = await axios.post('https://backend.ithyaraa.com/api/brand/refresh-token', { refreshToken });
                const newToken = data?.accessToken;
                const newRefresh = data?.refreshToken;
                if (newToken) setCookie('brand_access_token', newToken, 3); // 3 days
                if (newRefresh) setCookie('brand_refresh_token', newRefresh, 30); // 30 days
                api.defaults.headers.Authorization = `Bearer ${newToken}`;
                processQueue(null, newToken);
                return api(original);
            } catch (refreshErr) {
                processQueue(refreshErr, null);
                removeCookie('brand_access_token');
                removeCookie('brand_refresh_token');
                return Promise.reject(refreshErr);
            } finally {
                isRefreshing = false;
            }
        }
        return Promise.reject(error);
    }
);

const axiosInstance = api;
export default axiosInstance;


